export default "__VITE_ASSET__BOvYjEM5__"